import React, { HTMLProps } from 'react';
import classnames from 'classnames';
import CardHeader from './header';
import CardImage from './image';
import CardContent from './content';
import CardFooter from './footer';
import Element from '../../element';
import styles from './card.module.scss';

interface IProps extends HTMLProps<HTMLAnchorElement> {
    className?: string;
    children: React.ReactNode;
    domRef?: any;
}

function Card(props: IProps) {
    const { className, children, ...rest } = props;
    return (
        <Element className={classnames(styles['bm-card'], className)} {...rest}>
            {children}
        </Element>
    );
}

Card.Image = CardImage;
Card.Header = CardHeader;
Card.Content = CardContent;
Card.Footer = CardFooter;

export default Card;
